import { ReactNode } from 'react';

import { Text } from '@growtherapy/sprout-ui';

import { ScrollableGallery } from '../../components/ScrollableGallery';
import type { RemoteParticipant as TelehealthRemoteParticipant } from '../../video-sdk';
import { StopScreenShareButtonWrapper as StopScreenShareButton } from '../controls/StopScreenShareButtonWrapper';
import { RemoteParticipantWrapperProps } from './RemoteParticipantCell';

export interface MediaShareLayoutProps {
  remoteParticipants: TelehealthRemoteParticipant[];
  remoteScreenShareParticipant?: TelehealthRemoteParticipant;
  thumbnail: ReactNode;
  remoteParticipantComponent: (props: RemoteParticipantWrapperProps) => ReactNode;
  sharedMediaComponent: ReactNode;
}

export function MediaShareLayout({
  remoteParticipants,
  remoteScreenShareParticipant,
  remoteParticipantComponent: RemoteParticipantComponent,
  thumbnail,
  sharedMediaComponent,
}: MediaShareLayoutProps) {
  const screenShareParticipantName = remoteScreenShareParticipant?.displayName;

  return (
    <div className='rounded-2xl w-screen sm:w-full sm:h-full p-2 bg-neutral-800 rebrand:bg-surface-inverse'>
      <StopScreenShareButton />
      {remoteScreenShareParticipant && (
        <div data-dd-privacy='mask'>
          <Text variant='sm' className='text-neutral-100 text-center pb-2 fs-exclude rebrand:text-text-inverse'>
            {screenShareParticipantName} is sharing screen
          </Text>
        </div>
      )}
      <div className='flex flex-col sm:flex-row h-[calc(100%-3rem)] justify-between items-center'>
        {sharedMediaComponent}
        <div className='order-1 sm:order-2 sm:h-full w-full sm:w-[unset]'>
          <ScrollableGallery>
            {thumbnail}
            {remoteParticipants.map((remoteParticipant) => {
              return (
                <RemoteParticipantComponent
                  key={remoteParticipant.identity}
                  className='max-w-[15rem] min-w-[10rem] sm:min-w-[unset] max-h-[8.5rem] min-h-[7.875rem] w-auto h-full sm:mb-2 [&:not(:last-child)]:mr-2 sm:[&:not(:last-child)]:mr-0 flex-1 rounded-2xl border-neutral-800 border rebrand:border-border-state-selected-emphasis'
                  remoteParticipant={remoteParticipant}
                />
              );
            })}
          </ScrollableGallery>
        </div>
      </div>
    </div>
  );
}
